export const heroButtonThemes = {
  blue: {
    "--hero-button-bg-start": "#12284a",
    "--hero-button-bg-end": "#1f5da8",
    "--hero-button-border": "rgba(126, 165, 223, 0.34)",
    "--hero-button-shadow": "0 18px 42px rgba(17, 68, 136, 0.28)",
    "--hero-button-text": "#f2f2f2",
  },
  dark: {
    "--hero-button-bg-start": "rgba(255, 255, 255, 0.05)",
    "--hero-button-bg-end": "rgba(255, 255, 255, 0.08)",
    "--hero-button-border": "rgba(255, 255, 255, 0.12)",
    "--hero-button-shadow": "none",
    "--hero-button-text": "#f2f2f2",
  },
  light: {
    "--hero-button-bg-start": "#f3f3f3",
    "--hero-button-bg-end": "#ececec",
    "--hero-button-border": "rgba(255, 255, 255, 0.12)",
    "--hero-button-shadow": "none",
    "--hero-button-text": "#111111",
  },
};

export const heroButtons = {
  artist: {
    label: "View Work",
    href: "/work",
    variant: "blue",
  },
  brand: {
    label: "For Businesses",
    href: "/business",
    variant: "light",
  },
  widthDesktop: "250px",
  widthMobile: "100%",
  radius: "18px",
};
